// /src/api/packApi.js
import { axiosApi, axiosAuthApi } from "services/api";

// Chỉnh sửa gói
export const editPack = (header, data) => {
  return axiosAuthApi(header).post("/update/pack-proposal", data);
};

// Xóa gói
export const deletePack = (header, data) => {
  return axiosAuthApi(header).post("/delete/pack-proposal", data);
};

// Lọc các gói
export const filterPacks = (header, formData) => {
  return axiosAuthApi(header).post("/filter/pack-proposal", formData);
};


// Function to update a pack proposal
export const updatePackApi = (header, formData) => {
  return axiosAuthApi(header).post("/update/pack-proposal", formData);
};

export const getAllPacksForBrandApi = async (token, data, page) => {
  try {
    //       // check late: role brand must call it, role creator not 
    const response = await axiosApi.post(`/get/packs?page=${page}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error; // Return error to be handled in the action
  }
};


// API call to fetch all packs with filters
export const fetchMyPacks = async ({ token, data, page }) => {
  try {
    const response = await axiosApi.post(`/filter/pack-proposal?page=${page}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Assuming the response data is directly in `data`
  } catch (error) {
    throw error; // Throw the error to be handled by the action/reducer
  }
};

// API call to fetch single pack details
export const fetchSinglePack = async ({ token, data }) => {
  try {
    const response = await axiosApi.post("/get/pack-proposal", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Assuming the response data is directly in `data`
  } catch (error) {
    throw error; // Throw the error to be handled by the action/reducer
  }
};

// API call for adding a new pack proposal
export const addPackProposal = async (token, formData) => {
  try {
    const response = await axiosApi.post("/add/pack-proposal", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Return the response data
  } catch (error) {
    throw error; // Throw the error to be handled in the action/reducer
  }
};